// src/helpers/factories/menuTaxesFactory.ts
var menuTaxesFactory = (taxIds, taxes) => (taxIds || []).map((taxId) => ({
  id: taxId,
  onPress: () => null,
  title: taxes[taxId].name,
  status: true
}));

export { menuTaxesFactory };
